import React, { useContext } from "react";
import Products from "./products";
import { resultsFlattener } from "./productQueries";
import { Context } from "../../context";
const Woocommerceproductonsale = (props) => {
    const context = useContext(Context);
    const total = (props.attributes.rows || 1) * (props.attributes.columns || 3);
    const products = resultsFlattener(context.wc.onSaleProducts).results?.slice(0, total);
    return React.createElement(Products, { ...props, products: products });
};
export default Woocommerceproductonsale;
